export default import.meta.ROLLDOWN_FILE_URL_d8DuK08kuh$bOhr0YBGtcw